export class MercadoCambiario {
	fecha:string = '';
	fechaDescripcion:string = '';
	hora:string = '';
	precioApertura:string = '';
	precioCierre:string = '';
	precioMaximo:string = '';
	precioMinimo:string = '';
	precioPromedio:any;
	precioXHora:string = '';
	montoTotal:string = '';
}